import './App.scss';
import { ErrorBoundary } from 'react-error-boundary';
import CssBaseline from '@mui/material/CssBaseline';
import {ThemeProvider} from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';

import Router from './pages/Router';
import ExceptionPage from './pages/utilities/ExceptionPage';
import getTheme from './config/getTheme';

import AuthorizedGate from './AuthorizedGate';

const App = function App() {
  return (
    <ThemeProvider theme={getTheme()}>
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <CssBaseline />
        <ErrorBoundary fallback={<ExceptionPage/>}>
          <AuthorizedGate>
            <Router />
          </AuthorizedGate>
        </ErrorBoundary>
      </LocalizationProvider>
    </ThemeProvider>
  );;
};

export default App;
